@if (switchService.showInTenantShell()) {
  <button
    type="button"
    class="context-pill context-pill--button context-pill--location context-pill--icon sm:hidden!"
    [matMenuTriggerFor]="locationMenu"
    [attr.aria-label]="'header.locationSwitcher.menuLabel' | translate"
  >
    <i-tabler name="map-pin" class="context-pill__icon shrink-0"></i-tabler>
    <i-tabler name="chevron-down" class="context-pill__chevron shrink-0"></i-tabler>
  </button>

  <button
    type="button"
    class="context-pill context-pill--button context-pill--location hidden sm:inline-flex!"
    [matMenuTriggerFor]="locationMenu"
    [attr.aria-label]="'header.locationSwitcher.menuLabel' | translate"
  >
    <i-tabler name="map-pin" class="context-pill__icon shrink-0"></i-tabler>
    <span class="context-pill__label truncate">{{ switchService.activeLocation()?.name }}</span>
    <i-tabler name="chevron-down" class="context-pill__chevron shrink-0"></i-tabler>
  </button>

  <mat-menu #locationMenu="matMenu" class="cardWithShadow">
    <div class="px-4 py-2 text-xs font-semibold text-muted">
      {{ 'header.locationSwitcher.menuLabel' | translate }}
    </div>
    @for (location of switchService.accessibleLocations(); track location.id) {
      <button
        mat-menu-item
        type="button"
        (click)="selectLocation(location.id)"
        [disabled]="switchService.isActive(location.id)"
      >
        <span class="flex items-center gap-2 min-w-0">
          @if (switchService.isActive(location.id)) {
            <i-tabler name="check" class="text-primary shrink-0"></i-tabler>
          } @else {
            <span class="inline-block w-[18px] shrink-0"></span>
          }
          <span class="truncate">{{ location.name }}</span>
        </span>
      </button>
    }
  </mat-menu>
}
